import Launch16 from '@carbon/icons-react/es/launch/16';
import StarFilled24 from '@carbon/icons-react/es/star--filled/24';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Rate } from 'components/atoms/rate';
import { RoutePaths } from 'constant';
import { useTranslate, useTranslation } from 'hooks/use-translation';
import { BaseWidget } from '../common';
import { MainValue, Value } from './components';
import {
  loadingRender,
  noDataMessageFormatter,
  noDataRender,
} from './renderers';
import { WidgetState } from './state';

const RightAligned = styled.div`
  text-align: right;
`;
const RatingWrapper = styled(Value)`
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-02);
`;

interface Props<T, E> {
  value: WidgetState<T, E>;
}
export const AverageCsat: FC<Props<number, unknown>> = ({ value }) => {
  const translate = useTranslate();
  const resultRenderer = (result: number) => (
    <RatingWrapper>
      <MainValue>{String(result.toPrecision(2))}</MainValue>
      <Rate disabled value={result} character={<StarFilled24 />} />
    </RatingWrapper>
  );

  return (
    <BaseWidget>
      <BaseWidget.Title
        text={useTranslation(
          'reports.project_performance.widget.average_csat.title',
        )}
        actions={
          <RightAligned>
            <Link to={RoutePaths.csatReports} target="_blank">
              <Launch16 />
            </Link>
          </RightAligned>
        }
      />
      <BaseWidget.Content>
        {WidgetState.map(resultRenderer, loadingRender, () =>
          noDataRender(
            noDataMessageFormatter(
              <FormattedMessage id="reports.project_performance.widget.average_csat.no_value" />,
              translate,
            ),
          ),
        )(value)}
      </BaseWidget.Content>
    </BaseWidget>
  );
};
